import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-sector/compass-sector.js';
      import {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
import {RotType, RotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {CompassSectorPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-sector/compass-sector.js';

      export interface Props {
     heading?: number;
     courseOverGround?: number;
     headingSetpoint?: number | null;
     newHeadingSetpoint?: number | undefined;
     atHeadingSetpoint?: boolean;
     headingSetpointAtZeroDeadband?: number;
     headingSetpointOverride?: boolean;
     autoAtHeadingSetpoint?: boolean;
     autoAtHeadingSetpointDeadband?: number;
     animateSetpoint?: boolean;
     touching?: boolean;
     headingAdvices?: AngleAdvice[];
     minFOV?: number;
     rotType?: RotType | undefined;
     rotPosition?: RotPosition;
     rotationsPerMinute?: number;
     rotMaxValue?: number;
     rotPortStarboard?: boolean;
     rotAtZeroDeadband?: number;
     state?: InstrumentState;
     priority?: Priority;
     priorityElements?: CompassSectorPriorityElement[];
     tickmarksInside?: boolean;
     zoomToFitArc?: boolean
   }

      
  
      export type {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
export type {RotType, RotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {CompassSectorPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-sector/compass-sector.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcCompassSector',
  props: {
    heading: {},
    courseOverGround: {},
    headingSetpoint: {},
    newHeadingSetpoint: {},
    atHeadingSetpoint: { type: Boolean },
    headingSetpointAtZeroDeadband: {},
    headingSetpointOverride: { type: Boolean },
    autoAtHeadingSetpoint: { type: Boolean },
    autoAtHeadingSetpointDeadband: {},
    animateSetpoint: { type: Boolean },
    touching: { type: Boolean },
    headingAdvices: {},
    minFOV: {},
    rotType: {},
    rotPosition: {},
    rotationsPerMinute: {},
    rotMaxValue: {},
    rotPortStarboard: { type: Boolean },
    rotAtZeroDeadband: {},
    state: {},
    priority: {},
    priorityElements: {},
    tickmarksInside: { type: Boolean },
    zoomToFitArc: { type: Boolean }
  },
  emits: ["None"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onNone: (event: CustomEvent<unknown>) => emit('None', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-compass-sector',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})